import { Controller } from 'react-hook-form';
import { prop } from 'ramda';
import { Checkbox, Message } from '@fasstech/middle-design-system';
import getErrorMessage from '@@viewCommonComponents/controlled/helpers/getErrorMessage.js';

const ControlledCheckbox = ({
  rules = {},
  name,
  form,
  label = '',
  containerClassName = '',
  labelClassNames = '',
  disabled = false,
  displayError = true,
  isDisplayed = true,
  ...extraProps
}) => {
  if (!isDisplayed) {
    return null;
  }
  const labelClasses = labelClassNames;

  return (
    <div className={`w-full md:w-[100%]! ${containerClassName}`}>
      <Controller
        name={name}
        control={form.control}
        rules={rules}
        render={(props) => (
          <div className={'flex'}>
            <Checkbox
              {...props}
              {...props.field}
              {...extraProps}
              disabled={disabled}
              checked={props.field.value}
              className={'mr-2'}
            />
            <label
              className={labelClasses}
              onClick={() => {
                if (!disabled) {
                  props.field.onChange(!props.field.value);
                }
              }}>
              {label} {prop('required', rules) && '*'}
            </label>
          </div>
        )}
      />
      {displayError && (
        <Message variant="error" label={getErrorMessage(form.formState.errors, name)} />
      )}
    </div>
  );
};

export default ControlledCheckbox;
